module.exports = __webpack_public_path__ + "img/logo-popup.83c8e268.jpeg";